/**
 * Bff client functions.
 * @module ClientBff
 *
 */

import config from 'config';
import { getFeatureFlag, IS_HYBRID_CART_ACTIVE } from 'core/services/configcat';
import { request } from 'core/services/utilities';

import { getRequestId } from './get-request-id';
import { getRequestURL } from './helpers';

import type { BffResponse } from './client-bff.d';
import type { Utilities } from 'core/domains';

const { bff } = config;

/**
 * Client responsible for making requests to BFF.
 *
 */
export async function clientBff(
  resource: Utilities.PlainObject<string>,
  { accessToken, headers, payload, type, resellerId, ...params }: Utilities.PlainObject,
) {
  const { endpoint, method } = resource;

  const requestHeaders = {
    'Content-Type': 'application/json',
    Application: `${bff.applicationID}`,
    Authorization: `Bearer ${accessToken}`,
    client_id: `${bff.clientID}`,
    'session-id': getRequestId(),
    ...bff.getCustomHeaders?.(),
    ...headers,
  };

  const isHybridCart = await getFeatureFlag({
    flag: IS_HYBRID_CART_ACTIVE,
    defaultValue: false,
    resellerId,
  });

  const queryParams = {
    ...params,
    ...(isHybridCart ? { isHybridCart } : {}),
  } as Utilities.PlainObject;

  return request<BffResponse>({
    headers: requestHeaders,
    method,
    payload,
    type: type || 'JSON',
    url: getRequestURL(endpoint, queryParams),
  });
}
